import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const UserRequest = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) {
          setError("Aucun token trouvé. Veuillez vous connecter.");
          setLoading(false);
          return;
        }
        const response = await axios.get('https://appapi.unpaidfinancial.com/api/me', {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        });
        setUser(response.data);
      } catch (err) {
        setError('Erreur lors de la récupération des informations utilisateur.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  if (loading) {
    return <div style={styles.loading}>Chargement...</div>;
  }
  if (error) {
    return <div style={styles.error}>{error}</div>;
  }
  if (!user) {
    return <div style={styles.noData}>Aucune donnée utilisateur disponible.</div>;
  }

  // Génère les initiales de l'utilisateur pour l'avatar
  const getInitials = (nom, prenom) => {
    if (!nom && !prenom) return "?";
    return (
      (prenom ? prenom[0] : "") +
      (nom ? nom[0] : "")
    ).toUpperCase();
  };

  return (
    <div style={styles.outer}>
      <div style={styles.profileCard}>
        <div style={styles.avatarSection}>
          <div style={styles.avatar}>
            {getInitials(user.nom, user.prenom)}
          </div>
        </div>
        <div style={styles.infoSection}>
          <h2 style={styles.username}>
            {user.prenom} {user.nom}
          </h2>
          <div style={styles.infoRow}>
            <i className="fas fa-venus-mars" style={styles.icon}></i>
            <span>{user.sexe || "-"}</span>
          </div>
          <div style={styles.infoRow}>
  <i className="fas fa-calendar-alt" style={styles.icon}></i>
  <span>{user.dateNaissance || "-"}</span>
</div>

          <div style={styles.infoRow}>
            <i className="fas fa-home" style={styles.icon}></i>
            <span>{user.adresse || "-"}</span>
          </div>
          <div style={styles.infoRow}>
            <i className="fas fa-envelope" style={styles.icon}></i>
            <span>{user.email}</span>
          </div>
          <div style={styles.infoRow}>
            <i className="fas fa-phone-alt" style={styles.icon}></i>
            <span>{user.telephone}</span>
          </div>
          <div style={styles.infoRow}>
            <i className="fas fa-globe-africa" style={styles.icon}></i>
            <span>{user.pays}</span>
            <span style={styles.dot}>•</span>
            <span>{user.ville}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  outer: {
    minHeight: '100vh',
    background: 'linear-gradient(120deg, #6e8efb 0%, #a777e3 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileCard: {
    width: '100%',
    maxWidth: '400px',
    background: '#fff',
    borderRadius: '20px',
    boxShadow: '0 8px 24px 0 rgba(76, 68, 182, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 30px 32px',
    gap: '15px',
    animation: 'fade-in 1s',
  },
  avatarSection: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  avatar: {
    width: '90px',
    height: '90px',
    background: 'linear-gradient(135deg, #7f53ac 0%, #647dee 100%)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontWeight: 700,
    fontSize: '2.5rem',
    boxShadow: '0 4px 16px rgba(100, 125, 238, 0.2)',
    marginBottom: '12px',
  },
  infoSection: {
    width: '100%',
    textAlign: 'center',
  },
  username: {
    fontSize: '2rem',
    fontWeight: 'bold',
    margin: '10px 0 20px 0',
    color: '#7f53ac',
    letterSpacing: '1px',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    fontSize: '1.15rem',
    marginBottom: '15px',
    color: '#4e4e4e',
  },
  icon: {
    color: '#a777e3',
    fontSize: '1.15rem',
    minWidth: '22px',
  },
  dot: {
    fontSize: '1.5rem',
    margin: '0 7px',
    color: '#bdbdbd',
    fontWeight: 'bold',
    verticalAlign: 'middle',
  },
  loading: {
    textAlign: 'center',
    fontSize: '28px',
    marginTop: '15vh',
    color: '#7f53ac',
    letterSpacing: '2px',
  },
  error: {
    textAlign: 'center',
    fontSize: '24px',
    color: 'red',
    marginTop: '15vh',
  },
  noData: {
    textAlign: 'center',
    fontSize: '22px',
    marginTop: '15vh',
    color: '#666',
  },
};

export default UserRequest;
